class Plan {
    constructor() {
        this.id = 0
        this.name = ""
        this.quantity = 0
        this.premium = 0
        this.active = true
    }
}

class Product {
    constructor(user) {
        this.id = 0
        this.name = ""
        this.description = ""
        this.activeDays = 0
        this.multiple = false
        this.active = true
        this.control_panel = false
        this.external_code = ""
        this.user = user || "desconocido"
    }
}

class ProductDetail {
    constructor(user, id_fk) {
        this.id = 0
        this.id_fk = id_fk
        this.name = ""
        this.quantity = 0
        this.active = true
        this.user = user || "desconocido"
    }
}

export {
    Plan,
    Product,
    ProductDetail
}